import ProfileContactPersons from "@/pages/profiel/ContactPersons"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/contactpersonen")({
  component: RouteComponent,
})

function RouteComponent() {
  return <ProfileContactPersons />
}
